function secondsToString(seconds) {
  const timeString = seconds ? (new Date(seconds * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0] : '00:00:00'

  return timeString
}

function secondsToSsffString(seconds, frameRate) {
  const ssString = secondsToString(seconds)
  const ffString = (Math.trunc((seconds % 1) * frameRate) || 0).toString()

  const ssffString = ssString + ':' + (ffString.length < 2 ? '0' + ffString : ffString)

  return ssffString || 'hh:mm:ss:ff'
}

function ssffStringToSeconds(ssffString, frameRate) {
  if (checkSsffFormat(ssffString)) {
    const splitTime = ssffString.split(':')

    const hoursInSeconds = parseFloat(splitTime[0]) * 3600 || 0
    const minutesInSeconds = parseFloat(splitTime[1]) * 60 || 0
    const seconds = parseFloat(splitTime[2]) || 0
    const framesInSeconds = (parseFloat(splitTime[3]) + 1) / frameRate || 0

    const secondsTotal =  hoursInSeconds + minutesInSeconds + seconds + (framesInSeconds - 0.001)

    return secondsTotal
  } else {
    return -1
  }
}

function checkSsffFormat(ssffString) {
  const format = /(\d\d:[0-5]\d:[0-5]\d:\d\d)/
  const checkSsffFormat = format.test(ssffString)

  return checkSsffFormat
}

export default {
  secondsToString,
  secondsToSsffString,
  ssffStringToSeconds,
  checkSsffFormat
}